import styled from 'styled-components';

export const MainImageStyles = styled.div`
  z-index: -1;
  position: absolute;
  top: 90px;
  left: 50%;
  transform: translate(-50%, 0);
  max-width: 300px;
  width: 100%;
  margin: 0 auto;
  min-height: 500px;

  img {
    width: 100%;
  }
`;
